import { buttonClickEvent } from '@dashboard/junk-drawer/utils/eventstream';
/**
 * @param {String} vertical from the Vertical enum (e.g. "RESTAURANTS")
 * @param {String} promoType string representing the promo type being upsold
 * @returns {Object} ES2 event object
 */
export function clickPageUpsellCardPrimary(vertical, promoType) {
  return buttonClickEvent(`Page Upsell Card: ${vertical}: ${promoType}: Primary Click`);
}

/**
 * @param {String} vertical from the Vertical enum (e.g. "RESTAURANTS")
 * @param {String} promoType string representing the promo type being upsold
 * @returns {Object} ES2 event object
 */
export function dismissPageUpsellCard(vertical, promoType) {
  return buttonClickEvent(`Page Upsell Card: ${vertical}: ${promoType}: Dismiss`);
}